<template>
  <div class="application-create-component">

    <form @submit.prevent="saveApplication">

      <div class="form__group">

        <label class="form__label  form__label--block" for="title">{{ getTranslation('title') }} <span class="required">*</span> </label>

        <input v-model.trim="form.title" class="field  field--full-width" :class="{ 'field--error': $v.form.title.$error }" type="text" id="title">

        <div v-if="$v.form.title.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div class="form__group">

        <label class="form__label  form__label--block">{{ getTranslation('type') }}<span class="required">*</span></label>

        <v-select
            :options="formOptions.types"
            :reduce="option=>option.id"
            label="title"
            :placeholder="getTranslation('selectFromList')"
            :class="{'field--error':$v.form.typeId.$error}"
            v-model="form.typeId"
        />

        <div v-if="$v.form.typeId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>

      </div>

      <div class="form__group">

        <label class="form__label  form__label--block">{{ getTranslation('office') }}<span class="required">*</span></label>

        <v-select
            :options="formOptions.offices"
            :reduce="option=>option.id"
            label="title"
            :placeholder="getTranslation('selectFromList')"
            v-model="form.officeId"
            :class="{'field--error':$v.form.officeId.$error}"
        />

        <div v-if="$v.form.officeId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>

      </div>

      <div v-if="form.officeId && form.typeId !== APP_TYPE_DEMO" class="form__group">

        <label class="form__label  form__label--block">{{ getTranslation('dateAndTimeOccur') }}<span class="required">*</span></label>

        <DatePicker
            v-model="form.appDate"
            :pick-time="form.typeId !== APP_TYPE_DEMO"
            :format="form.typeId !== APP_TYPE_DEMO ? 'YYYY-MM-DD Hh:mm':'YYYY-MM-DD'"
            :display-format="form.typeId !== APP_TYPE_DEMO ? 'DD.MM.YYYY Hh:mm':'DD.MM.YYYY'"
            :placeholder="form.typeId !== APP_TYPE_DEMO ? 'дд.мм.гг чч:мм':'дд.мм.гг'"
        />

      </div>

      <div v-if="form.typeId === APP_TYPE_EKYZMAT" class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('contestType') }} <span class="required">*</span></label>
        <v-select
            :options="formOptions.contestTypes"
            :reduce="option=>option.id"
            label="title"
            :class="{'field--error':$v.form.appType.$error}"
            :placeholder="getTranslation('selectFromList')"
            v-model="form.appType"
        />
        <div v-if="$v.form.appType.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div v-if="showResourceTypes" class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('resourceType') }}</label>
        <v-select
            :options="formOptions.resources"
            :reduce="option=>option.id"
            label="title"
            :placeholder="getTranslation('selectFromList')"
            :class="{'field--error':$v.form.resourceType.$error}"
            v-model="form.resourceType"
        />
        <div v-if="$v.form.resourceType.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div v-if="showEkyzmatPositions" class="form__group">
        <StateSelect
            ref="stateSelect"
            :initialValue='[null, $route.query.departmentId]'
            :department-id.sync="departmentId"
            required
        />
        <div v-if="$v.form.resourceId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div v-if="showLocalPositions" class="form__group">
        <LocalStateSelect v-model="stateId"/>
      </div>

      <div v-if="showResource" class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('position') }}<span class="required">*</span></label>
        <v-select
            :options="formOptions.resourcePositions"
            :reduce="option=>option.id"
            label="positionName"
            :placeholder="getTranslation('selectFromList')"
            :class="{'field--error':$v.form.resourceId.$error}"
            v-model="form.resourceId"
        />
        <div v-if="$v.form.resourceId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div v-if="showNrkResource" class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('resource') }}<span class="required">*</span></label>
        <v-select
            :placeholder="getTranslation('selectFromList')"
            label="title"
            :reduce="option=>option.id"
            :options="nrkResources"
            :class="{'field--error':$v.form.resourceId.$error}"
            v-model="form.resourceId"
        />
        <div v-if="$v.form.resourceId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>

      <div class="form__group">
        <button class="btn btn--main" type="submit">{{ getTranslation('save') }}</button>
        <router-link :to="{ name: 'api.application.getList' }" class="btn btn--main-outline">{{ getTranslation('cancel') }}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import applicationMixin from '../mixins/application';
import {required} from 'vuelidate/lib/validators';
import StateSelect from '@/components/shared/StateSelect';
import hrmMethods from '@/views/admin/hrm/methods';
import LocalStateSelect from '@/components/shared/LocalStateSelect';
import testActionsMixin from '@/views/admin/events/mixin/testingEventAction';


export default {
  name: 'ApplicationCreateComponent',
  components: {LocalStateSelect, StateSelect},
  mixins: [applicationMixin, testActionsMixin],
  props: {
    action: {
      type: String,
      required: false,
      default: 'create',
    },
  },
  data() {
    return {
      showResourceTypes: false,
      showEkyzmatPositions: false,
      showLocalPositions: false,
      showResource: false,
      showNrkResource: false,
      departmentId: '',
      stateId: '',
      localStates: [],
      nrkResources: [],
    };
  },
  validations: {
    form: {
      title: {
        required,
      },
      typeId: {
        required,
      },
      officeId: {
        required,
      },
      resourceId: {
        required,
      },
      resourceType: {
        required,
      },
      appType: {
        required,
      },
    },
  }
  ,
  created() {
    this.fetchFormOptions();
  }
  ,
  watch: {
    'form.officeId'(val) {
      this.$router.replace({query: {officeId: val,typeId:this.form.typeId}}).catch(() => {
      });
    }
    ,
    'form.typeId'(val) {
      this.showResourceTypes = false;
      this.form.appType = '';
      this.form.officeId='';
      if (val) {
        this.filterResources(val);
        this.form.resourceType = '';
      } else
        this.showNrkResource = false;

    }
    ,
    'form.resourceType'(val) {
      this.filterResourceType(val);
    }
    ,
    'departmentId'(val) {
      this.showResource = false;
      this.form.resourceId = '';
      if (val && this.form.resourceType === this.RESOURCE_EKYZMAT_ID) {
        hrmMethods.fetchPositions(val).then(positions => {
          this.formOptions.resourcePositions = positions;
        });
        this.showResource = true;
      }
    }
    ,
    'stateId'(val) {
      this.showResource = false;
      this.form.resourceId = '';
      if (val && this.form.resourceType === this.RESOURCE_LOCAL_POSITIONS_ID) {
        this.fetchLocalPositions(val).then(() => {
          this.showResource = true;
        });
      }
    }
    ,
  }
  ,
  methods: {
    saveApplication() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return this.snotifyError('wrongFormMsg');
      }
      this.save();
    }
    ,
    filterResources(typeId) {

      switch (typeId) {
        case this.APP_TYPE_NRK:
          this.form.appType = 2;//contestType NRK
          break;
          case this.APP_TYPE_DEMO:
          this.form.appType = 10;//contestType demo
          break;

        case this.APP_TYPE_ATTESTATION:
          this.form.appType = 5;//contestType Attestation
          break;
        case this.APP_TYPE_RRK:
          this.form.appType = 6;//contestType RRK
          break;
        case this.APP_TYPE_MRK:
          this.form.appType = 7;//contestType MRK
          break;
      }


      this.formOptions.resources = this.formOptions.resourceTypes.filter(item => {

        switch (typeId) {
          case this.APP_TYPE_DEMO:
            if (item.id === this.RESOURCE_DEMO_ID)
              return item;
            break;
          case this.APP_TYPE_NRK:

            if (item.id === this.RESOURCE_NRK_ID)
              return item;

            break;

          case this.APP_TYPE_EKYZMAT:
            if (item.id === this.RESOURCE_EKYZMAT_ID || item.id === this.RESOURCE_LOCAL_POSITIONS_ID)
              return item;
            break;

          case this.APP_TYPE_ATTESTATION:
          case this.APP_TYPE_RRK:
          case this.APP_TYPE_MRK:
            if (item.id === this.RESOURCE_REGISTER_POST_ID)
              return item;

            break;

        }
      });
      this.showResourceTypes = true;
    }
    ,
    filterResourceType(typeId) {

      this.showEkyzmatPositions = false;
      this.showLocalPositions = false;
      this.form.resourceId = '';
      this.showResource = false;

      switch (typeId) {
        case this.RESOURCE_EKYZMAT_ID: {
          this.showEkyzmatPositions = true;
          break;
        }
        case this.RESOURCE_LOCAL_POSITIONS_ID: {
          this.fetchLocalStates().then(() => {
            this.showLocalPositions = true;
          });
          break;
        }
        case this.RESOURCE_NRK_ID:
          this.fetchNrkResources().then(() => {
            this.showNrkResource = true;
          });
          break;

        case this.RESOURCE_DEMO_ID:
          this.fetchDemoResources().then(() => {
            this.showNrkResource = true;
          });
          break;

        case this.RESOURCE_REGISTER_POST_ID:

          let typeId = this.form.typeId === this.APP_TYPE_MRK ? this.MRK_RESOURCE_ID : null;

          this.fetchRegisterPostResources(typeId).then(() => {
            this.showNrkResource = true;
          });
          break;
      }
    },

    fetchRegisterPostResources(typeId = null) {
      let params = {
        typeId: typeId || this.RESOURCE_REGISTER_POST_ID,
      };
      return this.axios.get(this.$config.urls.structure.fetchStructureResourceOptions.url, {params: params}).then(response => {
        this.nrkResources = response.data.data.map(item => {
          item.title = item.title + ' (' + item.resourceTitle + ')';
          return item;
        });
      }).catch(() => {
      });
    },

    fetchNrkResources() {
      let params = {
        typeId: this.RESOURCE_NRK_ID,
      };
      return this.axios.get(this.$config.urls.structure.fetchStructureResourceOptions.url, {params: params}).then(response => {
        this.nrkResources = response.data.data.map(item => {
          item.title = item.title + ' (' + item.resourceTitle + ')';
          return item;
        });
      }).catch(() => {
      });
    },
    fetchDemoResources() {
      let params = {
        typeId: this.RESOURCE_DEMO_ID,
      };
      return this.axios.get(this.$config.urls.structure.fetchStructureResourceOptions.url, {params: params}).then(response => {
        this.nrkResources = response.data.data.map(item => {
          item.title = item.title + ' (' + item.resourceTitle + ')';
          return item;
        });
      }).catch(() => {
      });
    },

    fetchLocalStates() {
      return this.axios.get(this.$config.urls.state.fetchStates.url).then(response => {
        this.localStates = response.data.data.items;
      }).catch(() => {
      });
    }
    ,

    fetchLocalPositions(stateId) {
      return this.axios.get(this.$config.urls.state.fetchStatePositions.url.replace(':id', stateId)).then(response => {
        this.formOptions.resourcePositions = response.data.data;
      }).catch(() => {
      });
    }
    ,

  }
  ,
}
;
</script>

<style scoped>

</style>
